import type { Officer, SourceMetric } from '../types'

export const officers: Officer[] = [
  {
    id: 'o-sarah',
    name: 'Sarah Johnson',
    initials: 'SJ',
    leadsAssigned: 184,
    leadsWorkedToday: 42,
    leadsRemaining: 18,
    pastDuePct: 14,
    pastDueCalls: 11,
    pastDueSms: 4,
    pastDueEmails: 2,
    speedToLeadSeconds: 251,
    contactRate: 42,
    bySource: [
      { sourceId: 'lendingtree', leads: 62, pastDuePct: 8, speedToLeadSeconds: 198, contactRate: 46 },
      { sourceId: 'zillow', leads: 41, pastDuePct: 19, speedToLeadSeconds: 320, contactRate: 38 },
      { sourceId: 'website', leads: 38, pastDuePct: 4, speedToLeadSeconds: 132, contactRate: 51 },
      { sourceId: 'realtor', leads: 26, pastDuePct: 16, speedToLeadSeconds: 402, contactRate: 33 },
      { sourceId: 'directmail', leads: 17, pastDuePct: 22, speedToLeadSeconds: 610, contactRate: 24 },
    ],
  },
  {
    id: 'o-marcus',
    name: 'Marcus Reyes',
    initials: 'MR',
    leadsAssigned: 171,
    leadsWorkedToday: 51,
    leadsRemaining: 9,
    pastDuePct: 6,
    pastDueCalls: 4,
    pastDueSms: 1,
    pastDueEmails: 1,
    speedToLeadSeconds: 164,
    contactRate: 47,
    bySource: [
      { sourceId: 'lendingtree', leads: 58, pastDuePct: 5, speedToLeadSeconds: 142, contactRate: 49 },
      { sourceId: 'zillow', leads: 39, pastDuePct: 7, speedToLeadSeconds: 180, contactRate: 45 },
      { sourceId: 'website', leads: 35, pastDuePct: 3, speedToLeadSeconds: 110, contactRate: 55 },
      { sourceId: 'realtor', leads: 24, pastDuePct: 9, speedToLeadSeconds: 205, contactRate: 41 },
      { sourceId: 'directmail', leads: 15, pastDuePct: 11, speedToLeadSeconds: 300, contactRate: 30 },
    ],
  },
  {
    id: 'o-dev',
    name: 'Devon Carter',
    initials: 'DC',
    leadsAssigned: 196,
    leadsWorkedToday: 24,
    leadsRemaining: 47,
    pastDuePct: 31,
    pastDueCalls: 29,
    pastDueSms: 9,
    pastDueEmails: 6,
    speedToLeadSeconds: 742,
    contactRate: 22,
    bySource: [
      { sourceId: 'lendingtree', leads: 71, pastDuePct: 34, speedToLeadSeconds: 820, contactRate: 19 },
      { sourceId: 'zillow', leads: 44, pastDuePct: 29, speedToLeadSeconds: 690, contactRate: 24 },
      { sourceId: 'website', leads: 33, pastDuePct: 18, speedToLeadSeconds: 410, contactRate: 31 },
      { sourceId: 'realtor', leads: 29, pastDuePct: 36, speedToLeadSeconds: 905, contactRate: 17 },
      { sourceId: 'directmail', leads: 19, pastDuePct: 41, speedToLeadSeconds: 1120, contactRate: 12 },
    ],
  },
  {
    id: 'o-lena',
    name: 'Lena Whitmore',
    initials: 'LW',
    leadsAssigned: 158,
    leadsWorkedToday: 47,
    leadsRemaining: 12,
    pastDuePct: 9,
    pastDueCalls: 6,
    pastDueSms: 2,
    pastDueEmails: 3,
    speedToLeadSeconds: 198,
    contactRate: 44,
    bySource: [
      { sourceId: 'lendingtree', leads: 54, pastDuePct: 7, speedToLeadSeconds: 165, contactRate: 47 },
      { sourceId: 'zillow', leads: 36, pastDuePct: 12, speedToLeadSeconds: 240, contactRate: 40 },
      { sourceId: 'website', leads: 31, pastDuePct: 5, speedToLeadSeconds: 128, contactRate: 52 },
      { sourceId: 'realtor', leads: 22, pastDuePct: 11, speedToLeadSeconds: 260, contactRate: 38 },
      { sourceId: 'directmail', leads: 15, pastDuePct: 14, speedToLeadSeconds: 380, contactRate: 27 },
    ],
  },
  {
    id: 'o-paul',
    name: 'Paul Ndiaye',
    initials: 'PN',
    leadsAssigned: 149,
    leadsWorkedToday: 33,
    leadsRemaining: 26,
    pastDuePct: 19,
    pastDueCalls: 15,
    pastDueSms: 5,
    pastDueEmails: 4,
    speedToLeadSeconds: 398,
    contactRate: 34,
    bySource: [
      { sourceId: 'lendingtree', leads: 49, pastDuePct: 17, speedToLeadSeconds: 350, contactRate: 36 },
      { sourceId: 'zillow', leads: 34, pastDuePct: 21, speedToLeadSeconds: 430, contactRate: 31 },
      { sourceId: 'website', leads: 28, pastDuePct: 10, speedToLeadSeconds: 220, contactRate: 44 },
      { sourceId: 'realtor', leads: 21, pastDuePct: 24, speedToLeadSeconds: 520, contactRate: 28 },
      { sourceId: 'directmail', leads: 17, pastDuePct: 27, speedToLeadSeconds: 700, contactRate: 21 },
    ],
  },
  {
    id: 'o-rita',
    name: 'Rita Solberg',
    initials: 'RS',
    leadsAssigned: 142,
    leadsWorkedToday: 44,
    leadsRemaining: 7,
    pastDuePct: 5,
    pastDueCalls: 3,
    pastDueSms: 1,
    pastDueEmails: 0,
    speedToLeadSeconds: 141,
    contactRate: 49,
    bySource: [
      { sourceId: 'lendingtree', leads: 47, pastDuePct: 4, speedToLeadSeconds: 120, contactRate: 52 },
      { sourceId: 'zillow', leads: 32, pastDuePct: 6, speedToLeadSeconds: 150, contactRate: 48 },
      { sourceId: 'website', leads: 27, pastDuePct: 2, speedToLeadSeconds: 96, contactRate: 58 },
      { sourceId: 'realtor', leads: 20, pastDuePct: 8, speedToLeadSeconds: 190, contactRate: 42 },
      { sourceId: 'directmail', leads: 16, pastDuePct: 9, speedToLeadSeconds: 250, contactRate: 33 },
    ],
  },
]

export const sourceMetrics: SourceMetric[] = [
  { sourceId: 'lendingtree', leads: 341, pastDuePct: 12, speedToLeadSeconds: 232, contactRate: 41 },
  { sourceId: 'zillow', leads: 226, pastDuePct: 16, speedToLeadSeconds: 335, contactRate: 37 },
  { sourceId: 'website', leads: 192, pastDuePct: 6, speedToLeadSeconds: 149, contactRate: 48 },
  { sourceId: 'realtor', leads: 142, pastDuePct: 18, speedToLeadSeconds: 414, contactRate: 32 },
  { sourceId: 'directmail', leads: 99, pastDuePct: 24, speedToLeadSeconds: 627, contactRate: 24 },
]

export const executiveMetrics = {
  overallPastDuePct: 12.4,
  pastDueCallPct: 9.1,
  pastDueSmsPct: 3.6,
  pastDueEmailPct: 2.2,
  speedToLeadSeconds: 222,
  contactRate: 38,
  leadsWorkedToday: 1284,
  leadsRemaining: 419,
  trends: {
    overallPastDuePct: -1.8,
    speedToLeadSeconds: -24,
    contactRate: 2.4,
    leadsWorkedToday: 8.1,
  },
}
